import React from 'react';
import { Typography } from '@material-ui/core';
import content from './content';

function Faq() {
  return (
    <div className="maxwidth">
      {content.map((el, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <div key={`FAQ_${index}`}>
          <Typography variant="body1">
            {index + 1}
            .
            {' '}
            {el.q}
          </Typography>
          <Typography variant="body2">{el.a}</Typography>
          <br />
        </div>
      ))}
    </div>
  );
}

export default Faq;
